import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Link as RouterLink } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase-config";
import { CardContent, Card, ListItemIcon, Skeleton } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import TextField from "@mui/material/TextField";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

function ListItemLink(props) {
  const { secondary, primary, to } = props;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef(function Link(itemProps, ref) {
        return <RouterLink to={to} ref={ref} {...itemProps} role={undefined} />;
      }),
    [to]
  );

  return (
    <li>
      <ListItem button component={renderLink}>
        <ListItemText primary={primary} secondary={secondary} />
        <ListItemIcon>
          <ArrowForwardRoundedIcon />
        </ListItemIcon>
      </ListItem>
    </li>
  );
}

export default function CompaniesList() {
  const [companies, setCompanies] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [searchValue, setSearchValue] = React.useState("");

  function handleSearchValueChange(e) {
    setSearchValue(e.target.value);
  }

  async function fetchAllCompanies() {
    const querySnapshot = await getDocs(collection(db, "companies"));

    const allDocs = [];
    querySnapshot.forEach((doc) => {
      const data = {
        ...doc.data(),
        id: doc.id,
      };
      allDocs.push(data);
    });
    setCompanies(allDocs);
    setLoading(false);
  }
  React.useEffect(() => {
    // Fetch all companies
    fetchAllCompanies();
  }, []);

  const k = companies.filter((com) =>
    com["name"].toLowerCase().includes(searchValue.toString().toLowerCase())
  );

  const nums = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  const theme = useTheme();

  const matchesMd = useMediaQuery(theme.breakpoints.up("md"));

  return loading ? (
    <>
      {matchesMd ? (
        <>
          <Grid
            container
            spacing={2}
            sx={{
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Grid item xs={12} md={6}>
              <Box sx={{ pt: 0.5 }}>
                <Skeleton width="100%" variant="rectangular" height={50} />
              </Box>
            </Grid>
          </Grid>
          <List dense={false}>
            <Grid container spacing={2}>
              {nums.map((num) => {
                return (
                  <Grid item xs={12} md={6} key={num}>
                    <Skeleton variant="rectangular" height={200} width="100%" />
                  </Grid>
                );
              })}
            </Grid>
          </List>
        </>
      ) : (
        <>
          <Grid
            container
            spacing={2}
            sx={{
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Grid item xs={12} md={6}>
              <Box sx={{ pt: 0.5 }}>
                <Skeleton width={500} variant="rectangular" height={50} />
              </Box>
            </Grid>
          </Grid>
          <List dense={false}>
            <Grid container spacing={2}>
              {nums.map((num) => {
                return (
                  <Grid item xs={12} md={6} key={num}>
                    <Skeleton variant="rectangular" height={200} width={500} />
                  </Grid>
                );
              })}
            </Grid>
          </List>
        </>
      )}
    </>
  ) : (
    <>
      <Grid
        container
        spacing={2}
        sx={{
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              display: "flex",
            }}
          >
            <TextField
              id="search-companies-text"
              label="Search..."
              fullWidth
              value={searchValue}
              onChange={handleSearchValueChange}
            />
          </Box>
        </Grid>
      </Grid>

      <List dense={false}>
        <Grid container spacing={2}>
          {k.map((company) => {
            return (
              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <ListItemLink
                      primary={company.name}
                      secondary={company.sector}
                      to={`/companies/${company["id"]}`}
                    />
                    {company["public"] ? (
                      <Typography>Public Company</Typography>
                    ) : (
                      <Typography>Private Company</Typography>
                    )}

                    <Typography>
                      {company["listed"] ? (
                        <Typography color="green" variant="subtitle2">
                          Listed
                        </Typography>
                      ) : (
                        <Typography color="red" variant="subtitle2">
                          Unlisted
                        </Typography>
                      )}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </List>
    </>
  );
}
